export const publicationStatusChoices = [
  { id: 'unpublished', name: 'common.unpublished' },
  { id: 'published', name: 'common.published' }
];
